import Header from "../ui/header/Header";
import {hasAdminGroup} from "../../util/AuthUtil";
import {useUser} from "../../context/UserContext";

interface AdminHeaderItem {
    title: string;
    to: string;
    adminOnly?: boolean;
}

export default function AdminHeader() {
    const {groups} = useUser();
    const isAdmin = hasAdminGroup(groups);

    const allItems: AdminHeaderItem[] = [
        {
            title: 'AI',
            to: 'ai',
            adminOnly: true
        },
        {
            title: 'Blog',
            to: 'blog',
            adminOnly: false
        },
        {
            title: 'Feedback',
            to: 'feedback',
            adminOnly: false
        },
        {
            title: 'Newsletter',
            to: 'newsletter',
            adminOnly: true
        },
        {
            title: 'Diagnostyka',
            to: 'diagnostyka',
            adminOnly: true
        },
        {
            title: 'Ścieżki',
            to: 'traces',
            adminOnly: true
        },
        {
            title: 'KED',
            to: 'ked',
            adminOnly: false
        },
        {
            title: 'Chat Webinaru',
            to: 'webinar-chat',
            adminOnly: false
        },
        {
            title: 'Transakcje',
            to: 'transakcje',
            adminOnly: true
        }
    ];

    const visibleItems = allItems.filter(item => !item.adminOnly || isAdmin);

    return <Header
        loaderId='adminRoot'
        useDarkTheme={true}
        mainPage={{
            title: 'Dashboard',
            to: '/admin'
        }} topItems={visibleItems.map(item => ({
        title: item.title,
        to: item.to
    }))}
        dropdownItems={[
            {
                title: 'Moje produkty',
                to: '/produkt'
            },
            {
                title: 'Ustawienia',
                to: '/ustawienia'
            },
            {
                title: 'Statystyki',
                to: '/statystyki'
            },
            {
                title: 'Rankingi',
                to: '/ranking'
            }
        ]}/>
}